<template>
  <div class="personalToken">
    <h2>パーソナルアクセストークンの発行</h2>
    <p>
      パーソナルアクセストークンは、APIへのアクセスを認証するためのトークンです。<br />
      以下のボタンをクリックして、パーソナルアクセストークンを発行してください。<br />
      発行後にページを離れると発行されたトークンを再度確認することができなくなりますので、ご注意ください。
    </p>
    <button @click="generateToken">パーソナルアクセストークンを発行</button>
    <div v-if="personalToken">
      <h3>発行されたパーソナルアクセストークン:</h3>
      <p>{{ personalToken }}</p>
      <p>このトークンはAPIへのアクセスに使用できます。</p>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import { useUserStore } from "../store/user.js";
const userStore = useUserStore();
const personalToken = ref("");
async function generateToken() {
  try {
    const res = await userStore.createpersonalToken(userStore._id, userStore.username);
    personalToken.value = res.token;
  } catch (error) {
    console.error("トークンの発行に失敗しました:", error);
    alert("トークンの発行に失敗しました。既に発行されているトークンが存在する可能性があります。", error.message);
  }
}
</script>